<script setup lang="ts">
type Props = {
  iso: string;
  size?: number;
};

const { size = 14 } = defineProps<Props>();
</script>

<template>
  <BaseIcon
    :key="iso"
    :size="size"
    :hard-coded-icon="`flag:${iso.toLowerCase()}-4x3`"
  />
</template>
